import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import {Permissoes} from "./permissoes";
import {PermissoesService} from "./permissoes.service";
import {MensagensService} from "max-ng-lib";

interface Permissao {
  validarPermissao: boolean;
  chave: Permissoes
}

@Injectable({ providedIn: 'root' })
export class AuthGuardChild implements CanActivateChild {

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private permissoesService: PermissoesService,
        private mensagemService: MensagensService,
        ) {}

  canActivateChild(childRoute?: ActivatedRouteSnapshot): Observable<true> | boolean {

    if (!this.authenticationService.estaAutenticado()) {
      this.router.navigate(['/login']);
      return false;
    }

    try {
      const dataRouter: Permissao = childRoute.data as Permissao;
      if (dataRouter && dataRouter.validarPermissao) {
        this.permissoesService.validarPermissaoRota(dataRouter.chave.getValor());
      }
    } catch (error) {
      this.mensagemService.exibaAlertaDeErros([error], 'Usuário sem permissão.');
      this.router.navigate(['/pages']);
      return false;
    }

    return true;
  }
}
